import React from "react";
import { Link } from "react-router-dom";

import fbIcon from "../assets/images/fb.png";
import xIcon from "../assets/images/x.png";
import instaIcon from "../assets/images/insta.png";
import whatsappIcon from "../assets/images/whatsApp.png";
import tiktokIcon from "../assets/images/tiktok.png";

const Footer = () => {
  return (
    <footer className="footer" data-aos="fade-up">
      <div className="container footer-top" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-start">
          <div className="col-lg-4 col-md-5 text-white mb-4 mb-lg-0" data-aos="fade-up" data-aos-delay="200">
            <h5 className="fw-bold">Help Desk</h5>
            <p className="mt-3 footer-help-text">
              Do you have questions or want
              <br />
              more information? Call now.
            </p>
            <div className="d-flex align-items-center mt-3">
              <span className="footer-phone-icon hover-scale-sm">
                <i className="bi bi-telephone-fill"></i>
              </span>
              <span className="ms-2 fw-bold">+971 54 263 1798</span>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 text-white mb-4 mb-lg-0" data-aos="fade-up" data-aos-delay="300">
            <div className="row">
              <div className="col-6">
                <nav className="nav flex-column footer-links">
                  <Link to="/" className="nav-link hover-underline">
                    Home
                  </Link>
                  <a href="#about" className="nav-link hover-underline">
                    About
                  </a>
                  <a href="#whyChooseUs" className="nav-link hover-underline">
                    Why Choose Us
                  </a>
                  <a href="#featured" className="nav-link hover-underline">
                    Featured
                  </a>
                  <a href="#screenshots" className="nav-link hover-underline">
                    Screenshots
                  </a>
                </nav>
              </div>
              <div className="col-6">
                <nav className="nav flex-column footer-links">
                  <Link to="/privacy-policy" className="nav-link hover-underline">
                    Privacy Policy
                  </Link>
                  <Link to="/terms-conditions" className="nav-link hover-underline">
                    Terms & Conditions
                  </Link>
                  <Link to="/support" className="nav-link hover-underline">
                    Support
                  </Link>
                  <Link to="/contact-us" className="nav-link hover-underline">
                    Contact Us
                  </Link>
                  <a href="#downloadApp" className="nav-link hover-underline">
                    Download App
                  </a>
                </nav>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-3 text-white" data-aos="fade-up" data-aos-delay="400">
            <h5 className="fw-bold ">
              Sign up for newsletter and <br className="br" /> get latest news & update
            </h5>
            <form
              className="footer-newsletter mt-3"
              onSubmit={(e) => e.preventDefault()}
              data-aos="zoom-in"
              data-aos-delay="450"
            >
              <input
                type="email"
                className="footer-input hover-focus"
                placeholder="Your Email"
              />
              <button type="submit" className="footer-subscribe-btn hover-rise-sm">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container d-flex justify-content-between align-items-center">
          <div className="text-white copyright">
            Copyright © 2025 Bazarna. All rights reserved.
          </div>
          <div className="footer-social d-flex align-items-center">
            <a className="fb-icon hover-scale-sm" href="#" aria-label="Facebook" data-aos="zoom-in" data-aos-delay="100">
              <img src={fbIcon} alt="Facebook" />
            </a>
            <a className="x-icon hover-scale-sm" href="#" aria-label="X" data-aos="zoom-in" data-aos-delay="150">
              <img src={xIcon} alt="X" />
            </a>
            <a className="whatsapp-icon hover-scale-sm" href="#" aria-label="WhatsApp" data-aos="zoom-in" data-aos-delay="200">
              <img src={whatsappIcon} alt="WhatsApp" />
            </a>
            <a className="insta-icon hover-scale-sm" href="#" aria-label="Instagram" data-aos="zoom-in" data-aos-delay="250">
              <img src={instaIcon} alt="Instagram" />
            </a>
            <a className="tiktok-icon hover-scale-sm" href="#" aria-label="TikTok" data-aos="zoom-in" data-aos-delay="300">
              <img src={tiktokIcon} alt="TikTok" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
